import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import React__default, { useState } from 'react';
import PropTypes from 'prop-types';
import { IlLoading, IlIcon, toast } from 'il-framework-component';
import classNames from 'classnames';
import 'axios';
import '../util.js';
import { OnSwitchIdentity } from '../APIRequets.js';

var BASE_CSS = 'il-header-switch-identity';
function SwitchIdentityList(_ref) {
  var linkedIdentitiesList = _ref.linkedIdentitiesList,
    applicationId = _ref.applicationId,
    hostUrl = _ref.hostUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showLoading = _useState2[0],
    setShowLoading = _useState2[1];
  var renderName = function renderName(name) {
    var _name$displayName = name.displayName,
      displayName = _name$displayName === void 0 ? '' : _name$displayName,
      _name$firstName = name.firstName,
      firstName = _name$firstName === void 0 ? '' : _name$firstName,
      _name$lastName = name.lastName,
      lastName = _name$lastName === void 0 ? '' : _name$lastName;
    return displayName || "".concat(firstName, " ").concat(lastName).trim();
  };
  var redirectUserToHome = function redirectUserToHome() {
    if (applicationId) {
      window.location.href = "/v3/apis/il-iam/navigate?applicationid=".concat(applicationId);
    } else {
      window.location.reload();
    }
  };
  var DisplayErrorMessage = function DisplayErrorMessage(error) {
    var errorMessage = '';
    if (error && (error.status === '400' || '403')) {
      errorMessage = 'You don’t have access to switch identity.';
    } else {
      errorMessage = 'Unexpected error occurred. Please try again later.';
    }
    toast({
      title: errorMessage,
      notificationType: 'toast',
      kind: 'error'
    });
  };
  var onSwitchIdentityClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      var reqData, requestOptions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setShowLoading(true);
            reqData = {
              principal: id,
              application: applicationId || ''
            };
            Object.keys(reqData).forEach(function (key) {
              if (reqData[key] === '') {
                delete reqData[key];
              }
            });
            requestOptions = {
              data: reqData
            };
            _context.prev = 4;
            _context.next = 7;
            return OnSwitchIdentity(requestOptions, hostUrl);
          case 7:
            setShowLoading(false);
            redirectUserToHome();
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            setShowLoading(false);
            DisplayErrorMessage(_context.t0);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 11]]);
    }));
    return function onSwitchIdentityClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React__default.createElement("div", null, showLoading && /*#__PURE__*/React__default.createElement(IlLoading, {
    active: true,
    withOverlay: true
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(BASE_CSS, "__list-wrapper")
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "".concat(BASE_CSS, "__list"),
    role: "menu",
    "aria-labelledby": "".concat(BASE_CSS, "__title")
  }, linkedIdentitiesList.length > 0 && linkedIdentitiesList.map(function (linkedIdentity) {
    var name = linkedIdentity.name,
      id = linkedIdentity.id,
      kind = linkedIdentity.kind,
      email = linkedIdentity.email,
      active = linkedIdentity.active;
    return /*#__PURE__*/React__default.createElement("li", {
      className: "".concat(BASE_CSS, "__list-item"),
      key: "".concat(id)
    }, /*#__PURE__*/React__default.createElement("span", {
      className: classNames("".concat(BASE_CSS, "__list-item-content-wrapper"), _defineProperty({}, "".concat(BASE_CSS, "__list-item-content-wrapper__active"), active)),
      role: "menuitemradio",
      "aria-checked": active,
      onClick: function onClick() {
        return onSwitchIdentityClick(id);
      },
      "data-testid": "".concat(BASE_CSS, "__list-item")
    }, /*#__PURE__*/React__default.createElement("div", {
      className: classNames("".concat(BASE_CSS, "__list-item-content"), _defineProperty({}, "".concat(BASE_CSS, "__list-item-content-has-check"), active))
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(BASE_CSS, "__list-item-icon")
    }, kind === 'IAM_USER' && /*#__PURE__*/React__default.createElement(IlIcon, {
      name: "user"
    }), kind === 'IAM_GROUP' && /*#__PURE__*/React__default.createElement(IlIcon, {
      name: "group"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(BASE_CSS, "__list-item-name-wrapper")
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(BASE_CSS, "__list-item-title")
    }, renderName(name)), /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(BASE_CSS, "__list-item-email")
    }, email))), active && /*#__PURE__*/React__default.createElement("div", {
      className: classNames(_defineProperty({}, "".concat(BASE_CSS, "__list-item-content-check-icon"), active))
    }, /*#__PURE__*/React__default.createElement(IlIcon, {
      name: "check-regular"
    }))));
  }))));
}
SwitchIdentityList.propTypes = {
  linkedIdentitiesList: PropTypes.array.isRequired,
  applicationId: PropTypes.string,
  hostUrl: PropTypes.string
};
SwitchIdentityList.defaultProps = {
  applicationId: ''
};

export { SwitchIdentityList };
